import type { MetricDim, SrvV2Module, WidgetType } from "@csbi/contracts"

export const METRIC_DOMAINS = [
  "users",
  "activity",
  "moduleUsage",
  "products",
  "applications",
  "packages",
  "submissions",
  "checklists",
  "projects",
  "changes",
  "watchlists",
  "tags",
  "reportsUsage",
  "lifecycle",
] as const
export type MetricDomain = (typeof METRIC_DOMAINS)[number]

export type ValueType = "count" | "duration_sec" | "ratio" | "timestamp" | "text"

export type Rollup = "sum" | "avg" | "max" | "last" | "distinct" | "none"

export type MetricDefinition = {
  id: string
  name: string
  description: string
  logic: string
  source?: string
  domain: MetricDomain
  srvModule: SrvV2Module
  priority: "must" | "nice" | "unspecified"
  valueType: ValueType
  dims: readonly MetricDim[]
  rollup: Rollup
  defaultWidget: WidgetType
  altWidgets?: readonly WidgetType[]
  /**
   * ⚠ It does **not** mean srv has aggregation logic we can lift: the old endpoint returns raw
   * documents (`Modules/Users.ts` is 24 lines of `find().select().lean()`), and those 22
   * metrics are computed downstream by the caller. So it neither drives the v2 implementation
   * order nor appears in the UI.
   */
  coveredByV1: boolean
  approximate?: boolean
  sensitive?: boolean
  caveat?: string
  xlsxRow: number
}

export function defineMetrics<T extends readonly MetricDefinition[]>(metrics: T): T {
  return metrics
}
